import { SocketContext } from 'app/socket/socketContext'
import { useContext } from 'react'

export const useSocket = () => {
  const socket = useContext(SocketContext)

  return socket
}
